import React from "react";

const Brochureenquiry = () => {
  return (
    <>
      <div className="rbt-contact-address">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6">
              <div className="thumbnail">
                <img
                  className="w-100 radius-6"
                  src="assets/images/about/contact.jpg"
                  alt="Contact Images"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="rbt-contact-form contact-form-style-1 max-width-auto">
                <div className="section-title text-start">
                  <span className="subtitle bg-primary-opacity">
                    EDUCATION FOR EVERYONE
                  </span>
                </div>
                <h3 className="title">
                  Get a Free Course You Can Contact With Me
                </h3>
                <form
                  id="contact-form"
                  method="POST"
                  action="mail.php"
                  className="rainbow-dynamic-form max-width-auto"
                >
                  <div className="form-group">
                    <input name="contact-name" id="contact-name" type="text" />
                    <label>Name</label>
                    <span className="focus-border"></span>
                  </div>
                  <div className="form-group">
                    <input name="contact-phone" type="email" />
                    <label>Email</label>
                    <span className="focus-border"></span>
                  </div>
                  <div className="form-group">
                    <input type="text" id="subject" name="subject" />
                    <label>Your Subject</label>
                    <span className="focus-border"></span>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="contact-message"
                      id="contact-message"
                    ></textarea>
                    <label>Message</label>
                    <span className="focus-border"></span>
                  </div>
                  <div className="form-submit-group">
                    <button
                      name="submit"
                      type="submit"
                      id="submit"
                      className="rbt-btn btn-md btn-gradient hover-icon-reverse w-100"
                    >
                      <span className="icon-reverse-wrapper">
                        <span className="btn-text">GET IT NOW</span>
                        <span className="btn-icon">
                          <i className="feather-arrow-right"></i>
                        </span>
                        <span className="btn-icon">
                          <i className="feather-arrow-right"></i>
                        </span>
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Brochureenquiry;
